export const TestModeBanner = ({ mode, pilot }) => {
  if (pilot) {
    return (
      <div
        data-testid="pilot-banner"
        role="status"
        className="w-full text-center text-[12px] font-semibold tracking-wide py-1.5"
        style={{ background: "var(--blue-soft)", color: "var(--blue-deep)", borderBottom: "1px solid #C9D4FF" }}
      >
        Pilot version: free for invited testers. Your feedback helps us improve.
      </div>
    );
  }
  if (mode !== "test") return null;
  return (
    <div
      data-testid="test-mode-banner"
      role="status"
      className="w-full text-center text-[12px] font-semibold tracking-wide py-1.5"
      style={{ background: "var(--amber-soft)", color: "var(--amber)", borderBottom: "1px solid #EAD7A8" }}
    >
      PAYMENTS IN TEST MODE. No real charges are made. Use Stripe test cards only.
    </div>
  );
};
